import { Box, Typography } from '@mui/material';
import React, { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as LogoMobile } from 'src/assets/svg/header-logo-mobile.svg';
import { ReactComponent as LogoDesktop } from 'src/assets/svg/header-logo-desktop.svg';
import { ReactComponent as LogoHos } from 'src/assets/svg/header-hos-logo.svg';
import { LanguageSelect } from 'src/components/language-select';
import { LoginDialog } from 'src/features/login-dialog/login-dialog';
import { LogoutDropdown } from 'src/components/logout-dropdown';
import { getTheme } from 'src/utils/getTheme';

import { AuthContext } from '../../providers/auth-context';

import { styles } from './styles';

export const Header: FC = () => {
    const { t } = useTranslation();
    const userState = useContext(AuthContext);

    const [isLoginDialogOpen, setIsLoginDialogOpen] = useState<boolean>(false);
    const { isHosTheme } = getTheme();

    const handleLoginClick = () => {
        setIsLoginDialogOpen(!userState.loggedIn);
    };

    const handleCloseLoginDialog = () => {
        setIsLoginDialogOpen(false);
    };

    const Logo = !isHosTheme ? (
        <>
            <LogoMobile css={styles.logoMobile} />
            <LogoDesktop css={styles.logoDesktop} />
        </>
    ) : (
        <>
            <LogoHos css={styles.logoMobile} />
            <LogoHos css={styles.logoDesktop} />
        </>
    );

    return (
        <Box css={styles.container}>
            {Logo}
            <Box css={styles.rightSide}>
                <LanguageSelect />
                {userState.loggedIn ? (
                    <LogoutDropdown />
                ) : (
                    <Typography variant="h4" css={styles.loginText} onClick={handleLoginClick}>
                        {t('header_login')}
                    </Typography>
                )}
                <LoginDialog open={isLoginDialogOpen} closeFn={handleCloseLoginDialog} />
            </Box>
        </Box>
    );
};
